module.exports = __webpack_public_path__ + "assets/img/hashTabActive.466c7f1a.svg";